// Returns the canonical refetchInterval value: poll every 2s while
// the query data still has in-flight work, otherwise stop polling.
export function inFlightInterval<T>(
  data: T | undefined,
  hasInFlight: (d: T) => boolean,
  intervalMs = 2000,
): number | false {
  if (!data) return false;
  return hasInFlight(data) ? intervalMs : false;
}
